import Index from '@/pages/teams/Index'
import List from '@/pages/teams/List'
import Create from '@/pages/teams/Create'
import Import from '@/pages/teams/Import'
import Modify from '@/pages/teams/Modify'

export default {
  path: 'teams',
  component: Index,  
  children: [
    {
      path: 'index',
      component: List
    },
    {
      path: 'create',
      component: Create
    },
    {
      path: 'import',
      component: Import
    },
    {
      path: 'modify/:id',
      component: Modify
    }
  ]
}
